module.exports = __webpack_public_path__ + "img/maintenance-active.dda8cf0a.svg";